import React from 'react';
import Rimg from './Rimg.jsx';
import Axios from 'axios';
import CartMini from '../components/CartMini';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import formatMoney from '@shopify/theme-currency';

class RelatedProduct extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { button: '' }

    this.cartMini = new CartMini();

    this._relatedProductClick = this._relatedProductClick.bind(this);
    this._addRelatedProduct = this._addRelatedProduct.bind(this);
    this.atcButton = this.atcButton.bind(this);
  }

  _addRelatedProduct(e) {
    e.preventDefault();
    this.setState({button: 'loading'});
    Axios.post('/cart/add.js', {
      'id': this.props.variant.id,
      'quantity': 1
    }).then(() => {
      this.cartMini.refresh().then(() => {
        this.setState({button: 'success'});
        this.cartMini.open(false);

        this.timeout = setTimeout(() => this.setState({button: ''}), 1000)
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({'event': 'Waitlist Add To Cart', 'waitlist_sku': this.props.variant.sku});
      window.heap && window.heap.track('ProductATC', {title: this.props.variant.title, vendor: this.props.product.vendor, price: this.props.variant.price, handle: this.props.product.handle, sku: this.props.variant.sku, location: 'Waitlist Recommendations'});
    }, (fail) => {
      this.setState({button: 'error'});
      this.timeout = setTimeout(() => this.setState({button: ''}), 1000)
      console.error(fail);
    })
  }

  _relatedProductClick(e, product) {
    e.preventDefault();
    this.props.onProductChange(product, this.props.variant);
  }

  atcButton() {
    if (this.state.button === 'loading') {
      return <div className="waitlist-cart button-loading">
        <div className="button-label-spinner">
          <svg className="svg-icon icon-spinner" xmlns="http://www.w3.org/2000/svg">
            <use xlinkHref="#reuse-spinner"></use>
          </svg>
        </div>
      </div>
    } else if (this.state.button === 'error') {
      return <a href={`/cart/add?id=${this.props.variant.id}`} data-no-instant className="waitlist-cart" onClick={e => this._addRelatedProduct(e)}>
        {this.context.i18n.addToCartError}
      </a>
    } else if (this.state.button === 'success') {
      return <a href={`/cart/add?id=${this.props.variant.id}`} data-no-instant className="waitlist-cart" onClick={e => this._addRelatedProduct(e)}>
        <span>
          {this.context.i18n.addedToCart}
        </span>
      </a>
    }
    return <a href={`/cart/add?id=${this.props.variant.id}`} data-no-instant className="waitlist-cart" onClick={e => this._addRelatedProduct(e)}>
      <span>
        {this.context.i18n.addToCart}
      </span>
    </a>
  }

  render() {
    return <div className="waitlist-related-item">
      <a href={`${this.props.product.url}?variant=${this.props.variant.id}`} onClick={e => this._relatedProductClick(e, this.props.product, this.props.variant)}>
        {this.props.product.media.length > 0 && <Rimg src={this.props.product.media[0].src} loading="lazy" width={this.props.product.media[0].width} height={this.props.product.media[0].height} />}
        <h4>{this.props.product.title.split('|')[0]}</h4>
        <h4 className="color">{this.props.product.title.split('|')[1]}</h4>
      </a>
      <span className="money">{Shopify.formatMoney(this.props.variant.price, Theme.moneyFormat)}</span>
      <this.atcButton />
    </div>
  }
}
RelatedProduct.contextType = ProductContext;

export default class Waitlist extends React.Component {
  constructor(props) {
    super();
    this.state = {
      email: '',
      error: '',
      success: false,
      relatedProducts: [],
      button: ''
    }

    this.inputRef = React.createRef();
    
    this.emailChange = this.emailChange.bind(this);
    this.waitlistSubmit = this.waitlistSubmit.bind(this);
    this.waitlistError = this.waitlistError.bind(this);
    this.waitlistForm = this.waitlistForm.bind(this);
    this.waitlistSuccess = this.waitlistSuccess.bind(this);
    this.waitlistButton = this.waitlistButton.bind(this);
    this.relatedProducts = this.relatedProducts.bind(this);
    this.getRelatedProducts = this.getRelatedProducts.bind(this);
    this._impression = this._impression.bind(this);
    this.focusInput = this.focusInput.bind(this);
  }

  emailChange(e) {
    this.setState({ 'email': e.target.value });
  }

  waitlistSubmit(e) {
    e.preventDefault();

    if (!this.props.currentVariant) {
      this.props._invalidVariant();
      return;
    } else {
      this.setState({ error: '', button: 'loading' })
      let gender = 'male';
      if (this.props.product.tags.includes('pf-gender:Female')) {
        gender = 'female';
      }

      let emailAddress = this.state.email;
      const bisOptions = { accepts_marketing: true };

      if (this.state.email && this.state.email.length > 0) {
        if (/@/.test(this.state.email)) {
          window._learnq.push(['identify', {'$email': this.state.email, '$gender': gender}]);
        } else {
          emailAddress = '';
          let digits = this.state.email.match(/\d/g);
          digits = digits ? digits.join('') : '';
          if (digits.length === 10) {
            digits = `+1${digits}`
          } else if (digits.length === 11 && digits[0] === '1') {
            digits = `+${digits}`
          }
          bisOptions.phone_number = digits;
        }
      }

      BIS.create(emailAddress, this.props.currentVariant.id, this.props.product.id, {...bisOptions}).then((resp) => {
        if (resp.status === 'OK') {
          this.setState({success: true, button: ''});
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ 'event': 'Waitlist Signup', 'waitlist_sku': this.props.currentVariant.sku });
          window.heap && window.heap.track('ProductWaitlistSignup', { title: this.props.currentVariant.title, vendor: this.props.currentVariant.vendor, price: this.props.currentVariant.price, handle: this.props.product.handle, sku: this.props.currentVariant.sku, options: this.props.currentVariant.title });
        } else {
          let msg = '';
          for (const k in resp.errors) {
            msg += ("\n" + resp.errors[k].join());
          }
          this.setState({ error: msg, button: 'error' });
          this.timeout = setTimeout(() => { this.setState({ button: '' }) }, 1000)
        }
      });
    }
  }

  waitlistError() {
    if (this.state.error === '') {
      return (null);
    }
    return <div className="error-message">{this.state.error}</div>
  }

  waitlistButton() {
    if (this.state.button === 'loading') {
      return <button className="app-button waitlist-button action-button button-loading" disabled type="submit">
        <div className="button-label-spinner">
          <SVG icon="spinner" />
        </div>
      </button>
    } else if (this.state.button === 'error') {
      return <button className="app-button waitlist-button action-button button-loading" disabled type="submit">
        Error
      </button>
    }
    return <button type="submit" className="action-button app-button waitlist-button button-active">{this.context.i18n.waitlistJoin}</button>
  }

  waitlistForm() {
    let inputProps = {
      type: 'email',
      placeholder: 'email@example.com'
    }
    if (this.props.product.tags.includes('bis-sms')) {
      inputProps = {
        type: 'text',
        placeholder: this.context.i18n.waitlistSMSPlaceholder,
        pattern: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$|^1?[-. ]??\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$"
      }
    }
    return <form className="waitlist-form" onSubmit={this.waitlistSubmit}>
      <this.waitlistError />
      <label htmlFor={`waitlist-email-${this.props.product.handle}`}>{this.props.product.tags.includes('bis-sms') ? this.context.i18n.waitlistSMSMesssage : this.context.i18n.waitlistMesssage}</label>
      <input id={`waitlist-email-${this.props.product.handle}`} {...inputProps} ref={this.inputRef} required="required" className="waitlist-email" onChange={this.emailChange} />
      <this.waitlistButton />
      {this.props.product.tags.includes('bis-sms') && <div className="waitlist-sms-details" dangerouslySetInnerHTML={{__html: this.context.i18n.smsDetails}}></div>}
    </form>
  }

  getRelatedProducts() {
    if (this.props.metafields.relatedStyles.handles) {
      const relatedProducts = this.props.metafields.relatedStyles.handles.split(',');
      for (let i of relatedProducts) {
        Axios.get(`/products/${i}.js`).then(product => {
          this.setState({ relatedProducts: [...this.state.relatedProducts, product.data] })
        });
      }
    }
  }

  relatedProducts() {
    if (!this.state.relatedProducts.length) {
      this.getRelatedProducts();
      return null;
    } else {
      const variantTitle = this.props.currentVariant.title.replace(/standard\s*\/\s*/i, '');
      const matchedRelatedProducts = this.state.relatedProducts.filter(function (product) {
        const variant = product.variants.find(v => variantTitle === v.title.replace(/standard\s*\/\s*/i, ''));
        if (variant && variant.available && this.count < 3) {
          this.count++;
          return true;
        }
        return false;
      }, { count: 0 });
      return <div className="waitlist-related-wrapper">
        <div className="waitlist-related-message">
          <h4>
            <SVG icon="check" />
            {this.context.i18n.waitlistRelated}
          </h4>
          <p>
            {this.context.i18n.waitlistRelatedMessage}
          </p>
        </div>
        <div className="waitlist-related">
          {matchedRelatedProducts.map((product, key) => {
            const variant = product.variants.find(v => variantTitle === v.title.replace(/standard\s*\/\s*/i, ''));
            return <RelatedProduct key={key} product={product} variant={variant} onProductChange={this.props.onProductChange} />
          })}
        </div>
      </div>
    }
  }

  waitlistSuccess() {
    return <div className="waitlist-success">
      <h4 className="waitlist-success-header">
        <SVG icon="check" />
        {this.context.i18n.waitlistSuccess}
      </h4>
      <p>{this.context.i18n.waitlistSuccessMessage}</p>
      <this.relatedProducts />
    </div>
  }

  _impression() {
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['setCustomVariables', 
      [
        {name: 'productWaitlist', value: 'true'}
      ]
    ]);
    window.monetateQ.push(["trackData", {"nonPageView": true}]);
    window.dataLayer = window.dataLayer || [];
    if (this.props.currentVariant) {
      window.dataLayer.push({'event':'Waitlist Impression', 'waitlist_impression_sku': this.props.currentVariant.sku});
      window.heap && window.heap.track('ProductWaitlistImpression', {title: this.props.currentVariant.name, vendor: this.props.currentVariant.vendor, price: this.props.currentVariant.price, handle: this.props.product.handle, sku: this.props.currentVariant.sku, options: this.props.currentVariant.title});
    }
  }

  focusInput() {
    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }

  componentDidMount() {
    this._impression();
    window.addEventListener('fitFinder:waitlist', this.focusInput);
  }

  componentWillUnmount() {
    window.removeEventListener('fitFinder:waitlist', this.focusInput);
  }

  render() {
    return <div className="waitlist-area">
      {this.state.success ? <this.waitlistSuccess /> : <this.waitlistForm />}
    </div>
  }
}

Waitlist.contextType = ProductContext;